/**
 * Layout Constants for React Grid Layout Integration
 * Defines all configuration, chart IDs, and responsive breakpoints
 */

// Chart IDs - must match grid item keys
export const CHART_IDS = {
    ORGANIC_VS_PAID: 'chart-organic-paid',
    WATERFALL: 'chart-waterfall',
    ORGANIC_VS_PAID_TIME: 'chart-organic-paid-time',
    PAID_DECOMP_TIME: 'chart-paid-decomp-time',
    AVG_CAC: 'chart-avg-cac',
    MARGINAL_CAC: 'chart-marginal-cac',
    SPEND_VS_ATTR_SHARE: 'chart-spend-vs-attr-share',
    RC_VS_ACTUAL: 'chart-rc-vs-actual'
};

// Map chart IDs to API response keys
export const CHART_KEY_MAP = {
    [CHART_IDS.ORGANIC_VS_PAID]: 'conv_attr/organic_vs_paid',
    [CHART_IDS.WATERFALL]: 'conv_attr/waterfall_by_variable',
    [CHART_IDS.ORGANIC_VS_PAID_TIME]: 'conv_attr/organic_vs_paid_over_time',
    [CHART_IDS.PAID_DECOMP_TIME]: 'conv_attr/paid_decomposition_over_time',
    [CHART_IDS.AVG_CAC]: 'bayes_eng_attr/avg_cac',
    [CHART_IDS.MARGINAL_CAC]: 'bayes_eng_attr/marginal_cac',
    [CHART_IDS.SPEND_VS_ATTR_SHARE]: 'bayes_eng_attr/spend_vs_attr_share',
    [CHART_IDS.RC_VS_ACTUAL]: 'response_curve/rc_vs_actual'
};

// Responsive breakpoints
export const BREAKPOINTS = {
    lg: 1200,
    md: 996,
    sm: 768,
    xs: 480,
    xxs: 0
};

// Column counts per breakpoint
export const COLS = {
    lg: 12,
    md: 10,
    sm: 6,
    xs: 4,
    xxs: 2
};

// Grid configuration
export const GRID_CONFIG = {
    cols: 12,
    rowHeight: 60,
    margin: [12, 12],
    containerPadding: [16, 16],
    maxRows: Infinity,
    compactType: 'vertical'
};

// Drag configuration
export const DRAG_CONFIG = {
    enabled: true,
    bounded: false,
    handle: '.drag-handle',
    cancel: 'input,button',
    threshold: 3
};

// Resize configuration
export const RESIZE_CONFIG = {
    enabled: true,
    handles: ['se']
};

// localStorage key
export const STORAGE_KEY = 'dashboard_layouts_v2';
export const STORAGE_VERSION = 2;
